module.exports = __webpack_public_path__ + "img/bubble6-active.678a6895.svg";